import Button from '@/components/UI/Button';
import Image from '@/components/UI/Image';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import { homeIntoDetail } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import SwiperCore, { EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';

SwiperCore.use([EffectFade]);

export default function Banner({ initData = [], router }: any) {
    const { Link, gtm } = useGlobal();
    // const homeGoDetail = (url: string) => {
    //     if (url) {
    //         router.push(url);
    //     }
    // };

    // 本地调试用
    // const gtm = {
    //     push: (obj:any) => console.log(obj)
    // }

    const { locale } = router;

    const getDataLayer = ({ position, type, banner_name }: any) => {
        const ret = {
            event: 'uaEvent',
            event_name: 'select_banner',
            banner_name,
            position,
            button_name: type,
        };

        return ret;
    };

    const getBuyDataLayer = (product_name: string) => {
        const ret = {
            event: 'uaEvent',
            event_name: 'buy',
            product_name,
            position: 'Homepage',
        };
        // console.log(ret)
        return ret;
    };

    const onImageClick = (params: any) => {
        const { item, position, event } = params;
        const $links: any = document.querySelectorAll('div.link a');
        if ($links.length && [...$links].every(($el) => !$el.contains(event.target))) {
            gtm.push(
                getDataLayer({
                    banner_name: `${item.phoneMainHeading} ${item.phoneSubHeading}`,
                    position,
                    type: 'Image',
                }),
            );
        } else if (!$links.length) {
            gtm.push(
                getDataLayer({
                    banner_name: `${item.phoneMainHeading} ${item.phoneSubHeading}`,
                    position,
                    type: 'Image',
                }),
            );
        }
    };

    const onSlideChange = (swiper: any) => {
        const $target: any = document.querySelector('.swiper-slide-active')?.querySelector('img.isInViewPort');
        if (!$target) return;
        const { bannerName = '', position = '', isReport = '0' } = $target.dataset;
        if (isReport === '1') return;
        if (!swiper?.realIndex) return;
        gtm.push({
            event: 'uaEvent',
            event_name: 'view_banner',
            banner_name: bannerName,
            position,
            nonInteraction: false,
        });
        $target.dataset.isReport = '1';
    };

    return (
        <div className={`${css.banners} index-bannersH5`} style={{ height: '800px' }}>
            <Swiper effect="fade" pagination={true} loop={true} onSlideChangeTransitionEnd={onSlideChange}>
                {initData.map((item: any, index: number) => (
                    <SwiperSlide
                        key={index}
                        onClick={(event) => {
                            onImageClick({
                                event,
                                item,
                                locale,
                                router,
                                position: `carousel banner_${index + 1}`,
                            });
                            homeIntoDetail(JSON.parse(item.buttonText)[0]?.buttonUrl, router);
                        }}
                    >
                        {item.phonePictureUrl && (
                            <Image
                                className="banner-img fullImgs isInViewPort"
                                src={item.phonePictureUrl}
                                layout="fill"
                                priority={true}
                                loading="eager"
                                alt={item.phoneMainHeading}
                                data-banner-name={item.phoneMainHeading}
                                data-position={`carousel banner_${index + 1}`}
                                data-is-report="0"
                            />
                        )}

                        <div className="banner-content">
                            {item.lable && <div className="new">{item.lable}</div>}
                            <h2
                                style={{
                                    color: item.textColor === 'white' ? '#fff' : '#000',
                                }}
                                className="title font-family-bold"
                            >
                                {item.phoneMainHeading}
                            </h2>
                            <p
                                style={{
                                    color: item.textColor === 'white' ? '#fff' : '#000',
                                }}
                                className="des"
                            >
                                {item.phoneSubHeading}
                            </p>
                            <div className="link">
                                {JSON.parse(item.buttonText).map(
                                    (el: { buttonUrl: string | undefined; buttonName: string | undefined }, idx: number) =>
                                        el.buttonUrl && (
                                            <Link
                                                href={el.buttonUrl}
                                                ariaLabel={item.phoneMainHeading}
                                                key={el.buttonUrl}
                                                // 通常第一个为 Learn More, 第二个为 Buy
                                                {...(idx === 0
                                                    ? {
                                                          dataLayer: getDataLayer({
                                                              banner_name: `${item.phoneMainHeading} ${item.phoneSubHeading}`,
                                                              position: `carousel banner_${index + 1}`,
                                                              type: 'Learn more',
                                                          }),
                                                      }
                                                    : {
                                                          dataLayer: [
                                                              getDataLayer({
                                                                  banner_name: `${item.phoneMainHeading} ${item.phoneSubHeading}`,
                                                                  position: `carousel banner_${index + 1}`,
                                                                  type: 'Buy',
                                                              }),
                                                              getBuyDataLayer(item.phoneMainHeading),
                                                          ],
                                                      })}
                                            >
                                                <Button
                                                    type="link"
                                                    className="link-btn font-family-medium"
                                                    aria-label={el.buttonName}
                                                    style={{ color: item.btnColor }}
                                                >
                                                    {el.buttonName}
                                                    <span className="more">
                                                        <EFArrowLeft />
                                                    </span>
                                                </Button>
                                            </Link>
                                        ),
                                )}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
